import { render, staticRenderFns } from "./RegistrationCompletion.vue?vue&type=template&id=a5a6d83c&scoped=true&"
import script from "./RegistrationCompletion.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompletion.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompletion.vue?vue&type=style&index=0&id=a5a6d83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a6d83c",
  null
  
)

export default component.exports